import React, { useEffect, useState } from 'react';
import PopUpLoader from './PopUpLoader';
import axios from 'axios';
import { read, utils, writeFile } from 'xlsx';

const AddBulkLeadPopup = (props) => {
    const [loadingToggle, setLoadingToggle] = useState(0);
    const [alertToggle, setAlertToggle] = useState(0);
    const [alertMessage, setAlertMessage] = useState("Lead successfully added");
    const [alertColor, setAlertColor] = useState("crm-color-green");
    const [userDetails, setUserDetails] = useState([]);
    const [csvFile, setCsvFile] = useState([]);
    const [leadLength, setLeadLength] = useState("");

    const url = window.url;
    const qry = new FormData();

    useEffect(() => {
        if (localStorage.getItem("user")) {
            const userData = JSON.parse(localStorage.getItem("user"));
            setUserDetails(userData);
            // console.log(userData);

            qry.append("emp_id", userData.user_id);

        }
    }, []);

    const addBulkLeadSubmit = (e) => {
        e.preventDefault();
        console.log(csvFile[0]);
        if (csvFile.length > 0) {

            if (Object.hasOwn(csvFile[0], 'phone') && Object.hasOwn(csvFile[0], 'lead_date')) {
                setLoadingToggle(1);
                // console.log(JSON.stringify(csvFile));
                // console.log(csvFile);
                const addLeadData = new FormData();
                addLeadData.append("emp_id", userDetails.user_id);
                addLeadData.append("data", JSON.stringify(csvFile));



                axios.post(url + "add-bulk-leads.php", addLeadData).then((response) => {
                    console.log(response.data);
                    if (response.data.status == 1) {
                        setLoadingToggle(0);
                        setAlertMessage(csvFile.length + " " + response.data.msg);
                        setAlertToggle(1);
                        props.reload();
                        setCsvFile([]);

                        setTimeout(() => {
                            props.close();
                        }, 500);
                    }
                })
            }
            else {
                alert("data format is wrong")
            }
        }
        else {
            alert("file is empty");
        }
    }

    const handleFile = ($event) => {
        // console.log(event.target.files[0]);

        const files = $event.target.files;
        if (files.length > 0) {
            const file = files[0];
            const reader = new FileReader();
            reader.onload = event => {
                const wb = read(event.target.result);
                const sheets = wb.SheetNames;

                if (sheets.length) {
                    const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);

                    if (rows.length > 0) {
                        if (Object.hasOwn(rows[0], 'phone') && Object.hasOwn(rows[0], 'lead_date')) {
                            setCsvFile(rows);
                            setLeadLength(rows.length + " Leads to assign");
                        }
                        else {
                            setLeadLength("data format is wrong");
                        }
                    }
                    else {
                        setLeadLength("file is empty !");
                    }

                }
            };
            reader.readAsArrayBuffer(file);

        }
        else {
            alert("file is empty");
        }
    }

    return (<>

        <div className="dark-background">
            <div className={loadingToggle == 1 || alertToggle == 1 ? 'add-new-lead-popup crm-overflow-h' : 'add-new-lead-popup'}>

                {loadingToggle == 1 ?
                    <PopUpLoader />
                    : <></>
                }

                {alertToggle == 1 ?
                    <div className='crm-alert'>
                        <p className={alertColor}> {alertMessage} </p>
                    </div>
                    : <></>
                }

                <div className='add-new-head'>
                    <h2> Add Bulk Leads <i className='fa fa-user-plus'></i> </h2>
                    <i className='fa fa-times cross' onClick={props.close}></i>
                </div>

                <div className='form'>
                    <form onSubmit={addBulkLeadSubmit}>
                        <label> Choose File </label>
                        <br />
                        <input type='file' accept=".xls, .xlsx, .csv" className='form-input' onChange={handleFile} required />

                        <p> {leadLength}</p>
                        <button type='submit' className='crm-btn-primary'> Add Lead </button>

                    </form>
                </div>

            </div>
        </div>
    </>);
}

export default AddBulkLeadPopup;